import {
  FaPlane,
  FaLeaf,
  FaCar,
  FaFlask,
  FaBuilding,
  FaShoppingBag,
  FaMicrochip,
  FaBolt,
  FaCoins,
  FaUtensils,
  FaHeartbeat,
  FaDesktop,
  FaTruck,
  FaIndustry,
  FaShip,
  FaHammer,
  FaWater,
  FaBriefcase
} from "react-icons/fa";

/**
 * Returns a unique FontAwesome icon component for each known industry to prevent repetition.
 * Falls back to FaBriefcase if no match is found.
 */
export const getIndustryFaIcon = (name) => {
  if (!name) return FaBriefcase;
  
  const n = name.toLowerCase();
  
  if (n.includes("aerospace") || n.includes("defen")) return FaPlane;
  if (n.includes("agri")) return FaLeaf;
  if (n.includes("auto") || n.includes("mobil")) return FaCar;
  if (n.includes("chemical") || n.includes("material")) return FaFlask;
  if (n.includes("construction") || n.includes("infrastructure")) return FaBuilding;
  if (n.includes("consum") || n.includes("retail") || n.includes("fmcg")) return FaShoppingBag;
  if (n.includes("electronic") || n.includes("semiconductor")) return FaMicrochip;
  if (n.includes("energy") || n.includes("power") || n.includes("utilit")) return FaBolt;
  if (n.includes("financ") || n.includes("bank") || n.includes("bfsi") || n.includes("insurance")) return FaCoins;
  if (n.includes("food") || n.includes("beverage")) return FaUtensils;
  if (n.includes("health") || n.includes("medical") || n.includes("pharma")) return FaHeartbeat;
  if (n.includes("tech") || n.includes("ict") || n.includes("communication")) return FaDesktop;
  if (n.includes("logis") || n.includes("supply") || n.includes("transportation")) return FaTruck;
  if (n.includes("manufac") || n.includes("industrial")) return FaIndustry;
  if (n.includes("marine") || n.includes("maritime")) return FaShip;
  if (n.includes("mining") || n.includes("metal")) return FaHammer;
  if (n.includes("water") || n.includes("waste") || n.includes("environmental")) return FaWater;

  return FaBriefcase;
};
